class UserStore {
    constructor() {
        this.userInfo = null;
        this.initUserInfo();
    }
    initUserInfo() {
        const storedInfo = localStorage.getItem("userInfo");
        this.userInfo = storedInfo ? JSON.parse(storedInfo) : null;
    }
    resetToken() {
        localStorage.clear();
    }
    setUserInfo(info) {
        this.userInfo = info;
        localStorage.setItem("userInfo", JSON.stringify(info));
    }
}
export const userStore = new UserStore();
